export type AssistantAudience = "patient" | "therapist";

export const LOGGED_OUT_PRIMARY_SUGGESTIONS = [
  "Pomozi mi da nađem terapeuta",
  "Koliko košta sesija?",
  "Kako izgleda online terapija?",
  "Kako da zakažem prvi termin?",
];

export const LOGGED_OUT_SECONDARY_SUGGESTIONS = [
  "Koji terapeut radi sa anksioznošću?",
  "Da li mogu da promenim terapeuta?",
];

export const CLIENT_PRIMARY_SUGGESTIONS = [
  "Kada mi je sledeća sesija?",
  "Gde ulazim u online sesiju?",
  "Koliko imam kredita?",
  "Ko je moj terapeut?",
];

export const CLIENT_SECONDARY_SUGGESTIONS = [
  "Treba mi novi terapeut",
  "Kako da promenim terapeuta?",
  "Gde su moje uplate i računi?",
  "Kako da otkažem ili pomerim termin?",
];

export const THERAPIST_PRIMARY_SUGGESTIONS = [
  "Koje sesije imam danas?",
  "Ko čeka moj odgovor?",
  "Sažmi razgovor sa klijentom",
  "Pregled zarade ovog meseca",
];

export const THERAPIST_SECONDARY_SUGGESTIONS = [
  "Koji klijenti traže pažnju?",
  "Kako da pomerim termin?",
  "Kako da povežem Google Calendar?",
  "Kako funkcionišu isplate?",
];

export function getAssistantAudience(
  role: string | undefined,
): AssistantAudience {
  return role === "THERAPIST" ? "therapist" : "patient";
}

export function getGreetingMessage(audience: AssistantAudience): string {
  return audience === "therapist"
    ? "Zdravo! Mogu da ti pomognem oko rasporeda, klijenata, poruka i drugih pitanja na platformi."
    : "Zdravo! Opiši mi šta te muči ili me pitaj bilo šta o terapiji, tu sam da pomognem.";
}
